/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type GridCellFormat = {
    isBold?: boolean;
    isUnderlined?: boolean;
    isItalic?: boolean;
    borderLeft?: boolean;
    borderRight?: boolean;
    borderTop?: boolean;
    borderBottom?: boolean;
    indent?: number;
    columnSpan?: number;
    horizontalAlignment?: GridCellFormat.horizontalAlignment;
    verticalAlignment?: GridCellFormat.verticalAlignment;
    fill?: (string | null);
    textColor?: (string | null);
};

export namespace GridCellFormat {

    export enum horizontalAlignment {
        LEFT = 'left',
        CENTER = 'center',
        RIGHT = 'right',
    }

    export enum verticalAlignment {
        TOP = 'top',
        CENTER = 'center',
        BOTTOM = 'bottom',
    }


}

